// extracted by mini-css-extract-plugin
var _1 = "EmailCreationForm-modulefieldInput__mRnQX";
var _2 = "EmailCreationForm-modulefieldInputMobile__Ezwno";
var _3 = "EmailCreationForm-modulefieldLabel__IgNXx";
var _4 = "EmailCreationForm-moduleformBody__hZad9";
var _5 = "EmailCreationForm-moduleinput__bD5Wm";
var _6 = "EmailCreationForm-moduleoverlayTag__gkusc RecipientTag-moduleRecipientTag__h6Gwc Tag-moduleTag__FLr9H";
var _7 = "EmailCreationForm-moduletoFieldContainer__r9sUz";
var _8 = "EmailCreationForm-moduletoFieldContainerMobile__msF5d";
export { _1 as "fieldInput", _2 as "fieldInputMobile", _3 as "fieldLabel", _4 as "formBody", _5 as "input", _6 as "overlayTag", _7 as "toFieldContainer", _8 as "toFieldContainerMobile" }
